<!-- 文档，知识分享 -->
<template>
  <div id="shareContainer">
    <el-dialog v-dialogDrag :visible.sync="isShowShare" :before-close="handleClose" :close-on-click-modal="false"
      :close-on-press-escape="false" custom-class="share-dialog" width="574px" height="390px" title=" " :show-close="false">
      <div class="content">
        <el-row class="tabs">
          <el-col :span="22" class="tab-item">
            <div class="bar-right is-active">
              分享
            </div>
          </el-col>
          <el-col :span="2" class="tab-item">
            <i class="el-icon-close" style="cursor: pointer;" @click="handleClose"></i>
          </el-col>
        </el-row>

        <div ref="mainCont" class="tab-con">
          <el-row style="height: 100%;">
            <el-col v-if="selectArr.length > 0" :span="12" class="left-con">
              <div class="box">
                <div class="file-shot">
                  <span class="blue">分享-</span>
                  <span v-if="isShowText !== 3" class="shot">{{
                    selectArr[0].folderName
                  }}</span>
                  <span v-if="isShowText === 3" class="shot"
                    style="max-width:70px;">{{ selectArr[0].folderName }}</span>
                  <span>等</span>
                  <span class="blue">{{ selectArr.length }}</span>
                  <span v-if="isShowText === 1">个文件</span>
                  <span v-if="isShowText === 2">个文件夹</span>
                  <span v-if="isShowText === 3">个文件或文件夹</span>
                </div>

                <el-form v-show="!putOutSuccess" ref="putOutForm" :model="putOutForm" class="form" label-width="100px"
                  label-position="top" size="small">
                  <el-form-item class="form-item" label="权限设置">
                    <el-checkbox v-model="putOutForm.permissionSettings" :disabled="isDown">允许下载</el-checkbox>
                  </el-form-item>
                  <el-form-item class="form-item" label="分享方式">
                    <el-radio-group v-model="putOutForm.sharingMode">
                      <el-radio label="1">
                        普通链接
                      </el-radio>
                      <el-radio label="2">
                        私密链接
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item class="form-item" label="有效期至">
                    <el-radio-group v-model="putOutForm.expiryDate">
                      <el-radio label="1">
                        永久
                      </el-radio>
                      <el-radio label="2">
                        <el-date-picker v-model="putOutForm.date" :picker-options="pickerOptions" :clearable="false"
                          :editable="false" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                          placeholder="选择日期" @focus="checkExpiryDate">
                        </el-date-picker>
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
                <div v-show="putOutSuccess && putOutForm.sharingMode === '1'" class="share-detail">
                  <p><span>分享链接：</span>{{ putOutSuccessData.url }}</p>
                </div>
                <div v-show="putOutSuccess && putOutForm.sharingMode === '2'" class="share-detail">
                  <p><span>分享链接：</span>{{ putOutSuccessData.url }}</p>
                  <p><span>提取密码：</span>{{ putOutSuccessData.pwd }}</p>
                </div>
                <!-- 二维码 -->
                <div class="QRCodeStyle">
                  <span v-if="putOutSuccess">二维码：</span>
                  <div id="qrcode" ref="qrcode"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="right-con">
              <ul>
                <li v-for="item in selectArr" :key="item.folderId">
                  <img :src="className(item)" style="flex-shrink:0;margin-right:3px;vertical-align:middle" />
                  <span>{{ item.folderName }}</span>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">
          取 消
        </el-button>
        <el-button v-if="!putOutSuccess" size="small" type="primary" @click="createPutOut">
          创建
        </el-button>
        <el-button v-else size="small" type="primary" @click="copyLink">
          复制链接
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import { dateFormatter } from "@/CommonDP/utils/common";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import QRCode from "qrcodejs2";
export default {
  props: {
    type: { default: 0, type: Number } //  1 项目文档 2 个人文档(2我的文档 3我的收藏)  3 企业文档 (4分享资料 5公共资料) 6部门文档
  },
  data() {
    return {
      pickerOptions: {
        // 禁用当前日期之前的时间
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      putOutForm: {
        sharingMode: "2", // 分享方式，默认为私密链接
        permissionSettings: false, // 权限设置，默认全选
        expiryDate: "2", // 有效期，默认为自定义时间
        date: "" // 已选择日期
      },
      desFileName: "",
      putOutSuccess: false, // 外发成功标志：true：外发成功；false：还未外发或外发失败
      putOutSuccessData: {}, // 存放外发成功后的数据：链接及密码
      isShowText: 0,
      isDown: true,
      downDesign: checkPermission(this.$allPerms.XTDESIGN_DOWN),
      downDesignMydoc: checkPermission(this.$allPerms.MYDOC_DOWN),
      downMycollection: checkPermission(this.$allPerms.MYCOLLECTION_DOWN),
      downSharinformation: checkPermission(this.$allPerms.SHARINFORMATION_DOWN),
      downPublicinformation: checkPermission(this.$allPerms.PUBLICINFORMATION_DOWN),
      downAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_DOWNLOAD),
      downAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_DOWNLOAD)

    };
  },
  computed: {
    ...mapState({
      isShowShare: (state) => state.XtDesign.isShowShare,
      selectArr: (state) => state.XtDesign.selectArr,
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerNav: (state) => state.router.routerNav
    }),
    prjId() {
      if (this.type === 1) return this.prjInfo.prjId;
      else if (this.type === 2 || this.type === 3) return "MyDoc";
      else if (this.type === 4 || this.type === 5) return "EnterpriseDoc";
      else if (this.type === 6) return "EnterpriseDeptDoc";
      else return "";
    },
    shareSource() {
      if (this.type === 1) return 0;
      else if (this.type === 2 || this.type === 3) return 1;
      else if (this.type === 4 || this.type === 5) return 2;
      else if (this.type === 6) return 3;
      else return "";
    }
  },

  watch: {},
  created() {
    this.getIsShow();
  },
  mounted() {
    this.putOutSuccess = false;
    this.putOutForm.date = dateFormatter(new Date(), "yyyy-MM-dd");
  },
  methods: {
    async getIsShow() {
      let textFlag = 0;
      let endName0 = "";
      let endName1 = "";
      for (let m = 0; m < this.selectArr.length; m++) {
        if (this.selectArr[m].isFolder === 0) endName0 = 0;
        else if (this.selectArr[m].isFolder === 1) endName1 = 1;

        if (endName0 === 0 && endName1 === 1) {
          this.desFileName = "个文件夹或文件";
          textFlag = 3;
          break;
        } else if (endName0 === 0) {
          this.desFileName = "个文件";
          textFlag = 1;
        } else if (endName1 === 1) {
          this.desFileName = "个文件夹";
          textFlag = 2;
        }
      }
      this.isShowText = textFlag;
      if (this.type === 1) {
        const bool = this.selectArr.every((item) => {
          return this.downDesign && item.isRead === 2 && item.folderType !== 14;
        });
        this.isDown = !bool;
      } else if (this.type === 2) {
        this.isDown = !this.downDesignMydoc;
      } else if (this.type === 3) {
        this.isDown = !this.downMycollection;
      } else if (this.type === 4) {
        this.isDown = !this.downSharinformation;
      } else if (this.type === 5) {
        this.isDown = !this.downPublicinformation;
      } else if (this.type === 6) {
        const result = await secondaryMenuService.queryEnterpriseDeptManager(this.enterpriseId);
        const obj = result.data.filter(({ folderId }) => folderId === this.$route.name)[0];
        const affiliationObj = this.routerNav.filter(({ folderId }) => folderId === this.$route.name)[0];
        const isAffiliation = affiliationObj.isAffiliation === 1;
        if (obj) {
          this.isDown = false;
        } else {
          if (isAffiliation) {
            this.isDown = !(this.downAllEnterpriseDeptDoc || this.downAffiliationEnterpriseDeptDoc);
          } else {
            this.isDown = !this.downAllEnterpriseDeptDoc;
          }
        }
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$store.dispatch("XtDesignUpdateSelect", []);
      this.$store.dispatch("XtDesignIsShowShare");
      this.$emit("click-event");
    },

    // 为不同的文件类型定义不同的icon样式类
    className(row) {
      return tableRowIcon(row);
    },

    // 监听日期选择器focus事件，使分享、外发的有效期项的自定义时间处于选中状态
    checkExpiryDate() {
      this.putOutForm.expiryDate = "2";
    },
    // 建立外发
    async createPutOut() {
      const folderList = [];
      let title = "";
      if (this.selectArr[0].folderName.length > 10) {
        title = this.selectArr[0].folderName.substring(0, 10) + "...等" + this.selectArr.length + this.desFileName;
      } else {
        title = this.selectArr[0].folderName + "等" + this.selectArr.length + this.desFileName;
      }
      for (const i of this.selectArr) {
        const obj = {
          id: i.folderId,
          name: i.folderName,
          isFile: i.isFolder
        };
        folderList.push(obj);
      }
      let isNeedPwd = void 0;
      // 普通链接和二维码不需要密码
      if (this.putOutForm.sharingMode === "1") isNeedPwd = 1;
      // 私密链接需要密码
      else if (this.putOutForm.sharingMode === "2") isNeedPwd = 0;

      let endDate = "";
      // 永久
      if (this.putOutForm.expiryDate === "1") endDate = "2099-12-31 23:59:59";
      // 自定义时间
      else if (this.putOutForm.expiryDate === "2") {
        endDate = this.putOutForm.date + " " + "23:59:59";
      }

      const isDownload = this.putOutForm.permissionSettings ? 1 : 0;
      const params = {
        prjId: this.prjId,
        enterpriseId: this.enterpriseId,
        folderList: folderList,
        isNeedPwd,
        endDate: endDate,
        isDownload,
        title: title,
        isOut: 1,
        shareSource: this.shareSource
      };
      // 普通链接或私密链接
      try {
        if (this.type === 1) delete params.enterpriseId;
        const res = await docService.genShareNewLink(params);
        if (res.result === "0") {
          const self = this;
          this.$message.success("文件分享成功！");
          this.qrcode(res.data.url);
          setTimeout(function () {
            self.putOutSuccess = true;
            self.putOutSuccessData = res.data;
          }, 300);
        }
      } catch (e) {
        this.$message.warning(e.message || "创建失败");
      }
    },

    // 复制链接
    copyLink() {
      let message = "";
      if (this.putOutForm.sharingMode === "1") {
        message = `${this.putOutSuccessData.url}`;
      } else if (this.putOutForm.sharingMode === "2") {
        message = `分享链接: ${this.putOutSuccessData.url}； 提取密码: ${this.putOutSuccessData.pwd}`;
      }
      this.$copyText(message).then((res) => {
        this.$message.success("链接复制成功！");
      });
    },
    qrcode(e) {
      new QRCode(this.$refs.qrcode, {
        width: 80, // 二维码宽度，单位像素
        height: 80, // 二维码高度，单位像素
        text: e // 生成二维码的链接
      });
    }
  }
};
</script>

<style lang="scss" src="./shareFile.scss" />
